module.exports = __webpack_public_path__ + "img/sj6.ddb9f708.png";